// extracted by mini-css-extract-plugin
export default {"AddLibrariesTagsDialog":"AddLibrariesTagsDialog_AddLibrariesTagsDialog__fMdji"};